import React, { useEffect } from 'react';
import { CAProvider } from './src-contexts-CAContext.js';
import { MiawChatProvider } from './src-contexts-MiawChatContext.js';
import Chat from './src-components-Chat-Chat.js';
import './src-components-Chat-Chat.styles.scss.js';
import { ChatbotProvider } from './src-contexts-ChatbotContext.js';
import { getChatWindowState, getChatSessionType, getIsUserLoggedInAtChatStart, getUnreadCount } from './src-utils-session-storage-utils.js';
import { CaseDataProvider } from './src-contexts-CaseDataContext.js';
import { getPageInfo } from './src-utils-app-utils.js';
import { CHAT_HEADER_TEXT, CHAT_BUTTON_TEXT } from './src-config-app-config.js';
import { initTranslations } from './src-utils-translations.js';
import { initChatConfig } from './src-utils-miaw-init-chat-utils.js';
import { useSwanCustomStyles } from './src-hooks-custom-hooks-useSwanCustomStyles.js';
import { useNRLogging } from './src-hooks-custom-hooks-useNRLogging.js';
import { isStudioPage } from './src-utils-chat-page-utils.js';
import { useIdentity } from '@vp/auth-react';

const Chatbot = ({ onChatButtonClick, locale, enableChatbot = true, tenant }) => {
  const { logCustomAttributesNR } = useNRLogging();
  const [chatConfig, setChatConfig] = React.useState();
  const [isTranslationsInitialized, setIsTranslationsInitialized] = React.useState(false);
  const [chatSession, setChatSession] = React.useState();
  const [chatWindowState, setChatWindowState] = React.useState("minimized");
  const [pageInfo, setPageInfo] = React.useState();
  const identity = useIdentity();
  useEffect(() => {
    if (typeof window === "undefined") return;
    initChatConfig(locale).then((data) => {
      setChatConfig(data);
    }).catch((error) => {
      console.error("Failed to initialize chat config:", error);
      logCustomAttributesNR("ca-chatbot-init-error", { logLevel: "error", message: error.message, errorType: "chatConfigError" });
    });
    initTranslations(locale).then(() => {
      setIsTranslationsInitialized(true);
    }).catch((error) => {
      console.error("Failed to load translations:", error);
      logCustomAttributesNR("ca-chatbot-init-error", { logLevel: "error", message: error.message, errorType: "translationsError" });
    });
    const { pageName, pageSection, pageStage } = getPageInfo();
    setPageInfo({ pageName, pageSection, pageStage });
    const chatWindowStateFromStorage = getChatWindowState();
    if (chatWindowStateFromStorage === "maximized") {
      setChatWindowState("maximized");
    } else {
      setChatWindowState("minimized");
    }
    const chatSesssionFromStorage = getChatSessionType();
    const { isSignedIn } = identity;
    if (isSignedIn === false && getIsUserLoggedInAtChatStart() === "true") {
      setChatSession("initial");
    } else if (chatSesssionFromStorage === "miawChatSession" || chatSesssionFromStorage === "chatbotSession") {
      setChatSession(chatSesssionFromStorage);
    } else {
      setChatSession("initial");
    }
    if (isStudioPage()) {
      if (chatSesssionFromStorage === "chatbotSession" || chatSesssionFromStorage === "miawChatSession") ; else {
        setChatWindowState("hidden");
      }
    }
  }, []);
  if (!chatSession || !isTranslationsInitialized || !chatConfig) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    CAProvider,
    {
      tenant,
      locale,
      chatWindow: chatWindowState,
      chatSession,
      enableChatbot,
      isPrivacyPolicyAccepted: chatSession !== "initial",
      chatButtonText: enableChatbot ? CHAT_BUTTON_TEXT.CHATBOT : CHAT_BUTTON_TEXT.MIAW_CHAT,
      chatHeaderText: enableChatbot ? CHAT_HEADER_TEXT.CHATBOT : CHAT_HEADER_TEXT.MIAW_CHAT,
      chatButtonHandler: () => {
      },
      chatWindowHandler: () => {
      },
      unreadMessages: getUnreadCount() || 0
    },
    /* @__PURE__ */ React.createElement(CaseDataProvider, { data: { pageInfo, queueType: "default" } }, /* @__PURE__ */ React.createElement(ChatbotProvider, { conversationMessages: [] }, /* @__PURE__ */ React.createElement(
      MiawChatProvider,
      {
        conversationMessages: [],
        sfConfig: {
          orgId: chatConfig?.orgId,
          developerName: chatConfig?.developerName,
          scrtURL: chatConfig?.scrtURL
        },
        queueInfo: chatConfig?.queueInfo,
        enableTypingIndicator: chatConfig?.enableTypingIndicator || false
      },
      /* @__PURE__ */ React.createElement(Chat, { onChatButtonClick })
    )))
  );
};
const ChatbotWrapper = (props) => {
  const { isLoading } = useSwanCustomStyles();
  if (isLoading) return /* @__PURE__ */ React.createElement(React.Fragment, null);
  return /* @__PURE__ */ React.createElement(Chatbot, { ...props });
};

export { ChatbotWrapper, ChatbotWrapper as default };
//# sourceMappingURL=src-components-Chat-ChatWrapper.js.map
